import {Panel, PanelBody, PanelHeader} from '@wordpress/components'
import PostEventsWidget from "../PostEventsWidget"
import PostRefererWidget from "../PostRefererWidget"
import PostPageviewsBarChartWidget from "../widgets/PostPageviewsBarChartWidget.js";

export const PageviewsPanel = ({postId})=>{
    return <Panel>
        <PanelHeader>Activity of the last 7 days</PanelHeader>
        <PanelBody>
           <PostPageviewsBarChartWidget postId={postId} />
        </PanelBody>
    </Panel>
}

export const EventsPanel = ({postId})=>{
    return <Panel>
        <PanelHeader>Events</PanelHeader>
        <PanelBody>
            <PostEventsWidget postId={postId} />
        </PanelBody>
    </Panel>
}

export const RefererPanel = ({postId})=>{
    return <Panel>
        <PanelHeader>Top Referer</PanelHeader>
        <PanelBody>
            <PostRefererWidget postId={postId} />
        </PanelBody>
    </Panel>
}